export const isFalsyOrEmpty = (obj: Record<string, unknown>): boolean => {
  if (!obj) return true;
  if (Object && obj.constructor === Object && Object.keys(obj).length === 0) return true;
  if (Array.isArray(obj) && obj.length === 0) return true;
  return false;
};

// Preserves a genuine 0 while treating unset/blank/non-numeric input as null, so callers can
// distinguish "explicitly configured to 0" from "not configured at all".
export const parseNumberOrNull = (value: string | null | undefined): number | null => {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isNaN(parsed) ? null : parsed;
};
